export default __webpack_public_path__ + "static/media/logo.ef257e3c.png";